import axios from 'axios'
import {ftHost} from '../util/helpers'

export function ftAppBase () {
  return ftHost() + '/v5/servlet'
}

export const ftAxios = axios.create({
  baseURL: ftAppBase(),
  withCredentials: true,
  timeout: 30000, // Wait up to 30 seconds for API response
  headers: {
    'Accept': 'application/json'
  }
})
